export const LANGS = ["pl","en","de","it","fr","es","ro","bg","hr","cs","sk"] as const;
export type Lang = (typeof LANGS)[number];

export const LANG_LABEL: Record<Lang, string> = {
  pl: "Polski",
  en: "English",
  de: "Deutsch",
  it: "Italiano",
  fr: "Français",
  es: "Español",
  ro: "Română",
  bg: "Български",
  hr: "Hrvatski",
  cs: "Čeština",
  sk: "Slovenčina"
};

export const LANG_FLAG: Record<Lang, string> = {
  pl: "🇵🇱",
  en: "🇬🇧",
  de: "🇩🇪",
  it: "🇮🇹",
  fr: "🇫🇷",
  es: "🇪🇸",
  ro: "🇷🇴",
  bg: "🇧🇬",
  hr: "🇭🇷",
  cs: "🇨🇿",
  sk: "🇸🇰"
};

export const translations = {
  pl: {
    // APP

    // AUTH
        authLoginBtn: "Zaloguj",
    authStartFreeTrial: "Rozpocznij bezpłatny okres próbny",
    authLogoutBtn: "Wyloguj",
    billingBuyNow: "Kup teraz",
    billingManageSubscription: "Zarządzaj subskrypcją",
    authTitleLogin: "Logowanie",
    authTitleRegister: "Utwórz konto",
    authSubtitleLogin: "Wpisz email i hasło",
    authSubtitleRegister: "Utwórz konto (min. 8 znaków)",
    authEmail: "Email",
    authPassword: "Hasło",
    authRepeatPassword: "Powtórz hasło",
    authSubmitLogin: "Zaloguj",
    authSubmitRegister: "Zarejestruj",
    authErrEmailRequired: "Email jest wymagany.",
    authErrPasswordMin8: "Hasło musi mieć co najmniej 8 znaków.",
    authErrPasswordMismatch: "Hasła nie są takie same.",
    authErrGeneric: "Coś poszło nie tak.",
    authAccept: "Akceptuję",
    authTerms: "Regulamin",
    authPrivacy: "Politykę prywatności / RODO",
    authErrLegalRequired:
  "Aby się zarejestrować, zaakceptuj Regulamin oraz Politykę prywatności / RODO.",

    authAcceptTermsPrefix: "Akceptuję",
    authAcceptPrivacyPrefix: "Akceptuję",
    authTermsLinkText: "Regulamin",
    authPrivacyLinkText: "Politykę prywatności / RODO",
    authErrMustAcceptLegal: "Aby się zarejestrować, zaakceptuj Regulamin oraz Politykę prywatności / RODO.",

    

    trialBannerText: "Okres próbny: pozostało {days} dni. Po zakończeniu wymagane będzie przejście na pełną wersję.",
    trialBannerCta: "Kup teraz",
    trialCheckoutComingSoon: "Płatności będą dostępne wkrótce.",
    postTrialCtaTitle: "Darmowy okres próbny zakończony",
    postTrialCtaText: "Aby dalej korzystać z pełnych stawek i funkcji, wykup dostęp do wersji FULL.",
    postTrialCtaButton: "Kup teraz",
demoCtaTitle: "Wersja DEMO",
    demoCtaText: "W DEMO liczona jest stawka 0.10 €/km. Zaloguj się lub załóż konto, żeby odblokować pełne stawki i panel admina.",

    adminOnboardingTitle: "Ustaw własne stawki",
    adminSetupButton: "Ustaw własne stawki",
    adminOnboardingText:
  "Możesz od razu liczyć trasy, ale warto uzupełnić własne stawki w panelu Admina. Przy pierwszym wejściu ustawisz też swój PIN.",
    adminOnboardingOpen: "Panel Admina",
    adminOnboardingLater: "Później",

    appTitle: "Szybka wycena transportu drogowego",
    hint:
      "Kliknij na mapie dwa regiony: najpierw start, potem cel.",
    start: "Start",
    destination: "Cel",
    clearSelection: "Wyczyść wybór",
    clickRegion: "Kliknij region na mapie",
    priceLabel: "Cena",
    ratesHint: "Ustaw własne stawki, aby wycena była dopasowana do Twojej firmy",
    driveTimeLabel: "Czas jazdy",
    truckEtaLabel: "Szacowany ETA ciężarówki",
    distanceLabel: "Dystans",
    loadLabel: "Ładunek",
    sendLabel: "Wyślij",
    palletShort: "pal.",
    quoteEmailSubject: "Wycena transportu",

    // SIDE MENU / SUMMARY
    routeSettings: "Ustawienia trasy",
    vehicleType: "Typ pojazdu",
    extraOptions: "Dodatkowe opcje",
    deadhead: "Dolot",
    deadheadHint: "Km dolotu doliczane do ceny w stawce startu.",
    deadheadPlaceholder: "0",
    distance: "Dystans",
    vehicleRate: "Stawka pojazdu",
    estimatedPrice: "Szacowana cena",
    advanced: "Zaawansowane",
    admin: "Stawki",
    perKm: "/ km",

    // VEHICLES
    vehicleVan: "🚐 BUS",
    vehicleSolo: "🚚 SOLÓWKA",
    vehicleTrailer: "🚛 ZESTAW",

    // EXTRA OPTIONS labels
    optMotorways: "Autostrady",
    optTolls: "Opłaty celne",
    optFerries: "Promy",
    optTunnels: "Tunele",

  optLift: "Winda",
    // COMMON ACTIONS
    cancel: "Anuluj",
    open: "Otwórz",
    save: "Zapisz",
    reset: "Reset",

    // PIN MODAL
    pinTitle: "Podaj PIN",
    pinDescOpenAdmin: "Wpisz swój PIN, aby otworzyć panel admina.",
    pinPlaceholder4: "PIN (4 cyfry)",
    pinOldPlaceholder4: "Stary PIN (4 cyfry)",
    pinNewPlaceholder4: "Nowy PIN (4 cyfry)",
    pinRepeatNew: "Powtórz nowy PIN",

    pinSetupTitle: "Ustaw PIN (4 cyfry)",
    pinChangeTitle: "Zmień PIN",
    pinSetupSubtitle: "Ustaw PIN tylko raz. Później będziesz go tylko wpisywać.",
    pinChangeSubtitle: "Podaj stary PIN, potem ustaw nowy.",

    pinErrEnter4Digits: "PIN musi mieć dokładnie 4 cyfry (0-9).",
    pinErrNew4Digits: "Nowy PIN musi mieć dokładnie 4 cyfry (0-9).",
    pinErrMismatch: "Nowe PINy nie są takie same.",
    pinErrOld4Digits: "Stary PIN musi mieć dokładnie 4 cyfry (0-9).",
    pinInvalid: "Błędny PIN.",

  // ADMIN PANEL
  adminPanelTitle: "Admin panel — stawki wyjazdu / powrotu",
  adminPanelBusBaseHint: "Wpisujesz stawki bazowe dla BUSA. SOLÓWKA i ZESTAW liczą się automatycznie według mnożników ustawionych niżej.",
  adminVehiclePercentTitle: "Mnożniki pojazdów",
  adminVehiclePercentHint: "Wpisz dopłatę procentową względem BUS.     Przykład: SOLÓWKA 73% oznacza, że SOLÓWKA liczy się jako BUS +73%.",
  adminVehicleBase: "baza",
  adminVehicleDefaultSolo: "domyślnie +73%",
  adminVehicleDefaultTrailer: "domyślnie +155%",
  adminVehicleKeepBusZero: "BUS zostaw 0%, jeśli stawki wpisujesz jako bazę dla busa.",
  changePin: "Zmień PIN",
  importFromExcel: "Import Excel",
  zone: "Strefa",
  outPerKm: "Wyjazd (OUT) €/km",
  inPerKm: "Powrót / trudniejsze kierunki (IN) €/km",
  rateLabel: "Stawka",
  pricingModeOutOutbound: "OUT (wyjazd)",
  pricingModeInReturn: "IN (powrót)",
  pricingModeInHardDirection: "IN (trudny kierunek)",
  ratesSaved: "Stawki zostały zapisane",
  defaultsRestored: "Przywrócono domyślne stawki",
  fileSelected: "Wybrano plik",
    // SHORT DISTANCE + DOMESTIC (AdminPanel)
    shortSettingsTitle: "Ustawienia krótkiego dystansu",
    shortMultiplierLabel: "Mnożnik short (np. 1.15 = +15%)",
    shortThresholdLabel: "Globalny krótki dystans do (km)",
    domesticRatesTitle: "Stawki krajowe (domestic)",
    domesticRatesHint: "Używane, gdy start i cel są w tym samym kraju (np. PL → PL).",
    domesticBusBaseHint: "To także jest stawka bazowa dla busa.",
    country: "Kraj",
    domPerKm: "DOM €/km",
    domesticShortKmLabel: "Short ≤ km",
    smartRouteTitle: "Szybkie wprowadzenie trasy",
    smartOriginPlaceholder: "Start: np. Rzeszów, Rzeszów PL, PL3, PL35-001",
    smartDestPlaceholder: "Cel: np. Hamburg, Hamburg DE, DE2, DE20095",
    smartPalletsPlaceholder: "Palety",
    smartWeightPlaceholder: "Waga (t)",
    smartSubmit: "Ustaw trasę",
},
  en: {
    // APP

    // AUTH
        authLoginBtn: "Log in",
    authStartFreeTrial: "Start free trial",
    authLogoutBtn: "Log out",
    billingBuyNow: "Buy now",
    billingManageSubscription: "Manage subscription",
    authTitleLogin: "Login",
    authTitleRegister: "Create account",
    authSubtitleLogin: "Enter your email and password",
    authSubtitleRegister: "Create an account (min. 8 characters)",
    authEmail: "Email",
    authPassword: "Password",
    authRepeatPassword: "Repeat password",
    authSubmitLogin: "Log in",
    authSubmitRegister: "Register",
    authErrEmailRequired: "Email is required.",
    authErrPasswordMin8: "Password must be at least 8 characters.",
    authErrPasswordMismatch: "Passwords do not match.",
    authErrGeneric: "Something went wrong.",
    authAccept: "I accept",
    authTerms: "Terms of Service",
    authPrivacy: "Privacy Policy / GDPR",
    authErrLegalRequired: "To register, you must accept the Terms of Service and the Privacy Policy / GDPR.",
    
    trialBannerText: "Trial: {days} days left. After it ends, upgrading to the full version will be required.",
    trialBannerCta: "Buy now",
    trialCheckoutComingSoon: "Payments will be available soon.",
    postTrialCtaTitle: "Free trial ended",
    postTrialCtaText: "To keep using full rates and features, upgrade to the FULL plan.",
    postTrialCtaButton: "Buy now",
demoCtaTitle: "DEMO version",
    demoCtaText: "In DEMO we use a flat 0.10 €/km. Log in or create an account to unlock full rates and the admin panel.",

    adminOnboardingTitle: "Set your own rates",
    adminSetupButton: "Set your own rates",
    adminOnboardingText:
  "You can calculate routes right away, but it’s worth adding your own rates in the Admin panel. On first entry, you’ll also set your PIN.",
    adminOnboardingOpen: "Admin panel",
    adminOnboardingLater: "Later",

    appTitle: "Fast road freight pricing in Europe",
    hint:
      "Click two regions on the map: first origin, then destination.",
    start: "Origin",
    destination: "Destination",
    clearSelection: "Clear selection",
    clickRegion: "Click a region on the map",
    priceLabel: "Price",
    ratesHint: "Set your own rates so the pricing matches your business",
    driveTimeLabel: "Driving time",
    truckEtaLabel: "Estimated truck ETA",
    distanceLabel: "Distance",
    loadLabel: "Load",
    sendLabel: "Send",
    palletShort: "plt.",
    quoteEmailSubject: "Transport quote",

    // SIDE MENU / SUMMARY
    routeSettings: "Route settings",
    vehicleType: "Vehicle type",
    extraOptions: "Extra options",
    deadhead: "Deadhead",
    deadheadHint: "Deadhead km are added to billed distance at the origin rate.",
    deadheadPlaceholder: "0",
    distance: "Distance",
    vehicleRate: "Vehicle rate",
    estimatedPrice: "Estimated price",
    advanced: "Advanced",
    admin: "Rates",
    perKm: "/ km",

    // VEHICLES
    vehicleVan: "🚐 VAN",
    vehicleSolo: "🚚 RIGID",
    vehicleTrailer: "🚛 ARTIC",

    // EXTRA OPTIONS labels
    optMotorways: "Motorways",
    optTolls: "Customs fees",
    optFerries: "Ferries",
    optTunnels: "Tunnels",

  optLift: "Tail lift",
    // COMMON ACTIONS
    cancel: "Cancel",
    open: "Open",
    save: "Save",
    reset: "Reset",

    // PIN MODAL
    pinTitle: "Enter PIN",
    pinDescOpenAdmin: "Enter your PIN to open the admin panel.",
    pinPlaceholder4: "PIN (4 digits)",
    pinOldPlaceholder4: "Old PIN (4 digits)",
    pinNewPlaceholder4: "New PIN (4 digits)",
    pinRepeatNew: "Repeat new PIN",

    pinSetupTitle: "Set PIN (4 digits)",
    pinChangeTitle: "Change PIN",
    pinSetupSubtitle: "Set the PIN once. Later you will only enter it.",
    pinChangeSubtitle: "Enter your old PIN, then set a new one.",

    pinErrEnter4Digits: "PIN must be exactly 4 digits (0-9).",
    pinErrNew4Digits: "New PIN must be exactly 4 digits (0-9).",
    pinErrMismatch: "The new PINs do not match.",
    pinErrOld4Digits: "Old PIN must be exactly 4 digits (0-9).",
    pinInvalid: "Invalid PIN.",

  // ADMIN PANEL
  adminPanelTitle: "Admin panel — outbound / return rates",
  adminPanelBusBaseHint: "You enter base rates for the VAN. RIGID and ARTIC are calculated automatically using the multipliers set below.",
  adminVehiclePercentTitle: "Vehicle multipliers",
  adminVehiclePercentHint: "Enter the percentage uplift compared to VAN. Example: RIGID 73% means RIGID is calculated as VAN +73%.",
  adminVehicleBase: "base",
  adminVehicleDefaultSolo: "default +73%",
  adminVehicleDefaultTrailer: "default +155%",
  adminVehicleKeepBusZero: "Leave VAN at 0% if your rates are entered as the van base rate.",
  changePin: "Change PIN",
  importFromExcel: "Import Excel",
  zone: "Zone",
  outPerKm: "Outbound (OUT) €/km",
  inPerKm: "Return / difficult directions (IN) €/km",
  rateLabel: "Rate",
  pricingModeOutOutbound: "OUT (outbound)",
  pricingModeInReturn: "IN (return)",
  pricingModeInHardDirection: "IN (difficult direction)",
  ratesSaved: "Rates have been saved",
  defaultsRestored: "Default rates restored",
  fileSelected: "Selected file",
    // SHORT DISTANCE + DOMESTIC (AdminPanel)
    shortSettingsTitle: "Short distance settings",
    shortMultiplierLabel: "Short multiplier (e.g. 1.15 = +15%)",
    shortThresholdLabel: "Global short distance up to (km)",
    domesticRatesTitle: "Domestic rates",
    domesticRatesHint: "Used when origin and destination are in the same country (e.g. PL → PL).",
    domesticBusBaseHint: "This is also the base rate for the van.",
    country: "Country",
    domPerKm: "DOM €/km",
    domesticShortKmLabel: "Short ≤ km",
    smartRouteTitle: "Quick route entry",
    smartOriginPlaceholder: "Origin: e.g. Rzeszów, Rzeszów PL, PL3, PL35-001",
    smartDestPlaceholder: "Destination: e.g. Hamburg, Hamburg DE, DE2, DE20095",
    smartPalletsPlaceholder: "Pallets",
    smartWeightPlaceholder: "Weight (t)",
    smartSubmit: "Set route",
},
  de: {
    // APP

    // AUTH
        authLoginBtn: "Anmelden",
    authStartFreeTrial: "Kostenlosen Test starten",
    authLogoutBtn: "Abmelden",
    billingBuyNow: "Jetzt kaufen",
    billingManageSubscription: "Abo verwalten",
    authTitleLogin: "Anmelden",
    authTitleRegister: "Konto erstellen",
    authSubtitleLogin: "E‑Mail und Passwort eingeben",
    authSubtitleRegister: "Konto erstellen (mind. 8 Zeichen)",
    authEmail: "E‑Mail",
    authPassword: "Passwort",
    authRepeatPassword: "Passwort wiederholen",
    authSubmitLogin: "Anmelden",
    authSubmitRegister: "Registrieren",
    authErrEmailRequired: "E‑Mail ist erforderlich.",
    authErrPasswordMin8: "Passwort muss mindestens 8 Zeichen haben.",
    authErrPasswordMismatch: "Passwörter stimmen nicht überein.",
    authErrGeneric: "Etwas ist schiefgelaufen.",
    authAccept: "Ich akzeptiere",
    authTerms: "Nutzungsbedingungen",
    authPrivacy: "Datenschutzerklärung / DSGVO",
    authErrLegalRequired:
  "Um sich zu registrieren, müssen Sie die Nutzungsbedingungen und die Datenschutzerklärung / DSGVO akzeptieren.",

    trialBannerText: "Testphase: Noch {days} Tage. Nach Ablauf ist ein Upgrade auf die Vollversion erforderlich.",
    trialBannerCta: "Jetzt kaufen",
    trialCheckoutComingSoon: "Zahlungen sind bald verfügbar.",
    postTrialCtaTitle: "Kostenlose Testphase beendet",
    postTrialCtaText: "Um weiterhin volle Tarife und Funktionen zu nutzen, wechsle auf den FULL‑Plan.",
    postTrialCtaButton: "Jetzt kaufen",
demoCtaTitle: "DEMO-Version",
    demoCtaText: "Im DEMO gilt ein fester Satz von 0,10 €/km. Melde dich an oder erstelle ein Konto, um volle Sätze und das Admin-Panel freizuschalten.",

    adminOnboardingTitle: "Eigene Tarife festlegen",
        adminSetupButton: "Eigene Tarife festlegen",
    adminOnboardingText:
  "Du kannst Routen sofort berechnen, aber es lohnt sich, deine eigenen Tarife im Admin-Panel zu ergänzen. Beim ersten Öffnen legst du auch deinen PIN fest.",
    adminOnboardingOpen: "Admin-Panel",
    adminOnboardingLater: "Später",

    appTitle: "Schnelle Straßenfracht-Preisberechnung in Europa",
    hint:
      "Klicke zwei Regionen auf der Karte: zuerst Start, dann Ziel.",
    start: "Start",
    destination: "Ziel",
    clearSelection: "Auswahl löschen",
    clickRegion: "Klicke eine Region auf der Karte",
    priceLabel: "Preis",
    ratesHint: "Lege eigene Tarife fest, damit die Kalkulation zu deinem Unternehmen passt",
    driveTimeLabel: "Fahrzeit",
    truckEtaLabel: "Geschätzte LKW-ETA",
    distanceLabel: "Entfernung",
    loadLabel: "Ladung",
    sendLabel: "Senden",
    palletShort: "Pal.",
    quoteEmailSubject: "Transportangebot",

    // SIDE MENU / SUMMARY
    routeSettings: "Routeneinstellungen",
    vehicleType: "Fahrzeugtyp",
    extraOptions: "Zusatzoptionen",
    deadhead: "Anfahrt",
    deadheadHint: "Anfahrts-km werden zum Abrechnungsweg addiert (Starttarif).",
    deadheadPlaceholder: "0",
    distance: "Distanz",
    vehicleRate: "Fahrzeugtarif",
    estimatedPrice: "Geschätzter Preis",
    advanced: "Erweitert",
    admin: "Preise",
    perKm: "/ km",

    // VEHICLES
    vehicleVan: "🚐 TRANSPORTER",
    vehicleSolo: "🚚 SOLO",
    vehicleTrailer: "🚛 SATTELZUG",

    // EXTRA OPTIONS labels
    optMotorways: "Autobahnen",
    optTolls: "Zollgebühren",
    optFerries: "Fähren",
    optTunnels: "Tunnel",

  optLift: "Hebebühne",
    // COMMON ACTIONS
    cancel: "Abbrechen",
    open: "Öffnen",
    save: "Speichern",
    reset: "Zurücksetzen",

    // PIN MODAL
    pinTitle: "PIN eingeben",
    pinDescOpenAdmin: "Gib deinen PIN ein, um das Admin-Panel zu öffnen.",
    pinPlaceholder4: "PIN (4 Ziffern)",
    pinOldPlaceholder4: "Alter PIN (4 Ziffern)",
    pinNewPlaceholder4: "Neuer PIN (4 Ziffern)",
    pinRepeatNew: "Neuen PIN wiederholen",

    pinSetupTitle: "PIN festlegen (4 Ziffern)",
    pinChangeTitle: "PIN ändern",
    pinSetupSubtitle: "Lege den PIN einmal fest. Später gibst du ihn nur noch ein.",
    pinChangeSubtitle: "Gib zuerst den alten PIN ein, dann den neuen.",

    pinErrEnter4Digits: "Der PIN muss genau 4 Ziffern haben (0-9).",
    pinErrNew4Digits: "Der neue PIN muss genau 4 Ziffern haben (0-9).",
    pinErrMismatch: "Die neuen PINs stimmen nicht überein.",
    pinErrOld4Digits: "Der alte PIN muss genau 4 Ziffern haben (0-9).",
    pinInvalid: "Falscher PIN.",

  // ADMIN PANEL
adminPanelTitle: "Adminpanel — Ausfahrt / Rückfahrt Tarife",
  adminPanelBusBaseHint: "Du gibst die Grundtarife für den TRANSPORTER ein. SOLO und SATTELZUG werden automatisch anhand der unten eingestellten Multiplikatoren berechnet.",
  adminVehiclePercentTitle: "Fahrzeug-Multiplikatoren",
  adminVehiclePercentHint: "Gib den prozentualen Aufschlag gegenüber dem TRANSPORTER ein. Beispiel: SOLO 73% bedeutet, dass SOLO als TRANSPORTER +73% berechnet wird.",
  adminVehicleBase: "Basis",
  adminVehicleDefaultSolo: "Standard +73%",
  adminVehicleDefaultTrailer: "Standard +155%",
  adminVehicleKeepBusZero: "Lass TRANSPORTER bei 0%, wenn du die Tarife als Basis für den Transporter eingibst.",
  changePin: "Ändere PIN",
  importFromExcel: "Import Excel",
  zone: "Zone",
  outPerKm: "Ausfahrt (OUT) €/km",
  inPerKm: "Rückfahrt / schwierige Richtungen (IN) €/km",
  rateLabel: "Tarif",
  pricingModeOutOutbound: "OUT (Ausfahrt)",
  pricingModeInReturn: "IN (Rückfahrt)",
  pricingModeInHardDirection: "IN (schwierige Richtung)",
  ratesSaved: "Tarife wurden gespeichert",
  defaultsRestored: "Standardtarife wurden wiederhergestellt",
  fileSelected: "Datei ausgewählt",
    // SHORT DISTANCE + DOMESTIC (AdminPanel)
    shortSettingsTitle: "Einstellungen für kurze Distanzen",
    shortMultiplierLabel: "Short-Multiplikator (z. B. 1.15 = +15%)",
    shortThresholdLabel: "Globale kurze Distanz bis (km)",
    domesticRatesTitle: "Inlandsraten",
    domesticRatesHint: "Verwendet, wenn Start und Ziel im selben Land liegen (z. B. PL → PL).",
    domesticBusBaseHint: "Auch das ist der Basistarif für den Transporter.",
    country: "Land",
    domPerKm: "DOM €/km",
    domesticShortKmLabel: "Kurz ≤ km",
    smartRouteTitle: "Schnelle Routeneingabe",
    smartOriginPlaceholder: "Start: z. B. Rzeszów, Rzeszów PL, PL3, PL35-001",
    smartDestPlaceholder: "Ziel: z. B. Hamburg, Hamburg DE, DE2, DE20095",
    smartPalletsPlaceholder: "Paletten",
    smartWeightPlaceholder: "Gewicht (t)",
    smartSubmit: "Route festlegen",
},
  it: {
    // APP

    // AUTH
        authLoginBtn: "Accedi",
    authStartFreeTrial: "Avvia prova gratuita",
    authLogoutBtn: "Esci",
    billingBuyNow: "Acquista ora",
    billingManageSubscription: "Gestisci abbonamento",
    authTitleLogin: "Accesso",
    authTitleRegister: "Crea account",
    authSubtitleLogin: "Inserisci email e password",
    authSubtitleRegister: "Crea un account (min. 8 caratteri)",
    authEmail: "Email",
    authPassword: "Password",
    authRepeatPassword: "Ripeti password",
    authSubmitLogin: "Accedi",
    authSubmitRegister: "Registrati",
    authErrEmailRequired: "L’email è obbligatoria.",
    authErrPasswordMin8: "La password deve avere almeno 8 caratteri.",
    authErrPasswordMismatch: "Le password non coincidono.",
    authErrGeneric: "Qualcosa è andato storto.",
    authAccept: "Accetto",
    authTerms: "Termini di servizio",
    authPrivacy: "Informativa sulla privacy / GDPR",
    authErrLegalRequired:
  "Per registrarti, devi accettare i Termini di servizio e l’Informativa sulla privacy / GDPR.",

    trialBannerText: "Prova: restano {days} giorni. Al termine sarà necessario passare alla versione completa.",
    trialBannerCta: "Acquista ora",
    trialCheckoutComingSoon: "I pagamenti saranno disponibili a breve.",
    postTrialCtaTitle: "Periodo di prova terminato",
    postTrialCtaText: "Per continuare a usare tariffe e funzioni complete, passa al piano FULL.",
    postTrialCtaButton: "Acquista ora",
demoCtaTitle: "Versione DEMO",
    demoCtaText: "In DEMO usiamo una tariffa fissa di 0,10 €/km. Accedi o crea un account per sbloccare le tariffe complete e il pannello admin.",

    adminOnboardingTitle: "Imposta le tue tariffe",
    adminSetupButton: "Imposta le tue tariffe",
    adminOnboardingText:
  "Puoi calcolare subito i percorsi, ma vale la pena inserire le tue tariffe nel pannello admin. Al primo accesso imposterai anche il tuo PIN.",
    adminOnboardingOpen: "Pannello admin",
    adminOnboardingLater: "Più tardi",

    appTitle: "Calcolo rapido dei costi di trasporto stradale in Europa",
    hint:
      "Clicca due regioni sulla mappa: prima partenza, poi destinazione.",
    start: "Partenza",
    destination: "Destinazione",
    clearSelection: "Azzera selezione",
    clickRegion: "Clicca una regione sulla mappa",
    priceLabel: "Prezzo",
    ratesHint: "Imposta le tue tariffe per adattare il calcolo alla tua azienda",
    driveTimeLabel: "Tempo di guida",
    truckEtaLabel: "ETA stimato del camion",
    distanceLabel: "Distanza",
    loadLabel: "Carico",
    sendLabel: "Invia",
    palletShort: "pal.",
    quoteEmailSubject: "Preventivo trasporto",

    // SIDE MENU / SUMMARY
    routeSettings: "Impostazioni percorso",
    vehicleType: "Tipo veicolo",
    extraOptions: "Opzioni extra",
    deadhead: "Avvicinamento",
    deadheadHint: "I km di avvicinamento si aggiungono alla distanza fatturata (tariffa di partenza).",
    deadheadPlaceholder: "0",
    distance: "Distanza",
    vehicleRate: "Tariffa veicolo",
    estimatedPrice: "Prezzo stimato",
    advanced: "Avanzate",
    admin: "Tariffe",
    perKm: "/ km",

    // VEHICLES
    vehicleVan: "🚐 FURGONE",
    vehicleSolo: "🚚 RIGIDO",
    vehicleTrailer: "🚛 AUTOARTICOLATO",

    // EXTRA OPTIONS labels
    optMotorways: "Autostrade",
    optTolls: "Dazi doganali",
    optFerries: "Traghetti",
    optTunnels: "Gallerie",

  optLift: "Sponda idraulica",
    // COMMON ACTIONS
    cancel: "Annulla",
    open: "Apri",
    save: "Salva",
    reset: "Reset",

    // PIN MODAL
    pinTitle: "Inserisci PIN",
    pinDescOpenAdmin: "Inserisci il PIN per aprire il pannello admin.",
    pinPlaceholder4: "PIN (4 cifre)",
    pinOldPlaceholder4: "Vecchio PIN (4 cifre)",
    pinNewPlaceholder4: "Nuovo PIN (4 cifre)",
    pinRepeatNew: "Ripeti nuovo PIN",

    pinSetupTitle: "Imposta PIN (4 cifre)",
    pinChangeTitle: "Cambia PIN",
    pinSetupSubtitle: "Imposta il PIN una sola volta. In seguito dovrai solo inserirlo.",
    pinChangeSubtitle: "Inserisci il vecchio PIN, poi imposta quello nuovo.",

    pinErrEnter4Digits: "Il PIN deve contenere esattamente 4 cifre (0-9).",
    pinErrNew4Digits: "Il nuovo PIN deve contenere esattamente 4 cifre (0-9).",
    pinErrMismatch: "I nuovi PIN non coincidono.",
    pinErrOld4Digits: "Il vecchio PIN deve contenere esattamente 4 cifre (0-9).",
    pinInvalid: "PIN non valido.",

  // ADMIN PANEL
adminPanelTitle: "Pannello admin — tariffe uscita / ritorno",
  adminPanelBusBaseHint: "Inserisci le tariffe base per il FURGONE. RIGIDO e AUTOARTICOLATO vengono calcolati automaticamente in base ai moltiplicatori impostati sotto.",
  adminVehiclePercentTitle: "Moltiplicatori veicolo",
  adminVehiclePercentHint: "Inserisci la maggiorazione percentuale rispetto al FURGONE. Esempio: RIGIDO 73% significa che RIGIDO viene calcolato come FURGONE +73%.",
  adminVehicleBase: "base",
  adminVehicleDefaultSolo: "predefinito +73%",
  adminVehicleDefaultTrailer: "predefinito +155%",
  adminVehicleKeepBusZero: "Lascia FURGONE a 0% se inserisci le tariffe come base per il furgone.",
  changePin: "Cambia PIN",
  importFromExcel: "Import Excel",
  zone: "Zona",
outPerKm: "Uscita (OUT) €/km",
inPerKm: "Ritorno / direzioni difficili (IN) €/km",
rateLabel: "Tariffa",
pricingModeOutOutbound: "OUT (uscita)",
pricingModeInReturn: "IN (ritorno)",
pricingModeInHardDirection: "IN (direzione difficile)",
  ratesSaved: "Le tariffe sono state salvate",
  defaultsRestored: "Tariffe predefinite ripristinate",
  fileSelected: "File selezionato",
    // SHORT DISTANCE + DOMESTIC (AdminPanel)
    shortSettingsTitle: "Impostazioni breve distanza",
    shortMultiplierLabel: "Moltiplicatore short (es. 1.15 = +15%)",
    shortThresholdLabel: "Breve distanza globale fino a (km)",
    domesticRatesTitle: "Tariffe nazionali",
    domesticRatesHint: "Usato quando origine e destinazione sono nello stesso paese (es. PL → PL).",
    domesticBusBaseHint: "Anche questa è la tariffa base per il furgone.",
    country: "Paese",
    domPerKm: "DOM €/km",
    domesticShortKmLabel: "Breve ≤ km",
    smartRouteTitle: "Inserimento rapido del percorso",
    smartOriginPlaceholder: "Partenza: es. Rzeszów, Rzeszów PL, PL3, PL35-001",
    smartDestPlaceholder: "Destinazione: es. Amburgo, Amburgo DE, DE2, DE20095",
    smartPalletsPlaceholder: "Pallet",
    smartWeightPlaceholder: "Peso (t)",
    smartSubmit: "Imposta percorso",
},
  fr: {
    // APP

    // AUTH
        authLoginBtn: "Se connecter",
    authStartFreeTrial: "Démarrer l’essai gratuit",
    authLogoutBtn: "Se déconnecter",
    billingBuyNow: "Acheter maintenant",
    billingManageSubscription: "Gérer l’abonnement",
    authTitleLogin: "Connexion",
    authTitleRegister: "Créer un compte",
    authSubtitleLogin: "Saisissez votre e‑mail et votre mot de passe",
    authSubtitleRegister: "Créer un compte (min. 8 caractères)",
    authEmail: "E‑mail",
    authPassword: "Mot de passe",
    authRepeatPassword: "Répéter le mot de passe",
    authSubmitLogin: "Se connecter",
    authSubmitRegister: "S’inscrire",
    authErrEmailRequired: "L’e‑mail est requis.",
    authErrPasswordMin8: "Le mot de passe doit contenir au moins 8 caractères.",
    authErrPasswordMismatch: "Les mots de passe ne correspondent pas.",
    authErrGeneric: "Une erreur s’est produite.",
    authAccept: "J’accepte",
    authTerms: "Conditions d’utilisation",
    authPrivacy: "Politique de confidentialité / RGPD",
    authErrLegalRequired:
  "Pour vous inscrire, vous devez accepter les Conditions d’utilisation et la Politique de confidentialité / RGPD.",

    trialBannerText: "Essai : il reste {days} jours. Après la fin, le passage à la version complète sera requis.",
    trialBannerCta: "Acheter maintenant",
    trialCheckoutComingSoon: "Les paiements seront bientôt disponibles.",
    postTrialCtaTitle: "Essai gratuit terminé",
    postTrialCtaText: "Pour continuer à utiliser les tarifs et fonctionnalités complets, passe au plan FULL.",
    postTrialCtaButton: "Acheter maintenant",
demoCtaTitle: "Version DEMO",
    demoCtaText: "En DEMO, nous utilisons un tarif fixe de 0,10 €/km. Connectez‑vous ou créez un compte pour débloquer les tarifs complets et le panneau d’administration.",

    adminOnboardingTitle: "Définis tes propres tarifs",
    adminSetupButton: "Définis tes propres tarifs",
    adminOnboardingText:
  "Tu peux calculer des trajets tout de suite, mais cela vaut la peine d’ajouter tes propres tarifs dans le panneau admin. Lors du premier accès, tu définiras aussi ton PIN.",
    adminOnboardingOpen: "Panneau admin",
    adminOnboardingLater: "Plus tard",

    appTitle: "Estimation rapide du transport routier en Europe",
    hint:
      "Clique deux régions sur la carte : d’abord départ, puis destination.",
    start: "Départ",
    destination: "Destination",
    clearSelection: "Effacer la sélection",
    clickRegion: "Clique une région sur la carte",
    priceLabel: "Prix",
    ratesHint: "Définis tes propres tarifs pour adapter le calcul à ton entreprise",
    driveTimeLabel: "Temps de conduite",
    truckEtaLabel: "ETA estimée du camion",
    distanceLabel: "Distance",
    loadLabel: "Chargement",
    sendLabel: "Envoyer",
    palletShort: "pal.",
    quoteEmailSubject: "Devis transport",

    // SIDE MENU / SUMMARY
    routeSettings: "Paramètres de l’itinéraire",
    vehicleType: "Type de véhicule",
    extraOptions: "Options supplémentaires",
    deadhead: "Approche",
    deadheadHint: "Les km d’approche s’ajoutent à la distance facturée (tarif départ).",
    deadheadPlaceholder: "0",
    distance: "Distance",
    vehicleRate: "Tarif véhicule",
    estimatedPrice: "Prix estimé",
    advanced: "Avancé",
    admin: "Tarifs",
    perKm: "/ km",

    // VEHICLES
    vehicleVan: "🚐 FOURGON",
    vehicleSolo: "🚚 PORTEUR",
    vehicleTrailer: "🚛 ARTICULÉ",

    // EXTRA OPTIONS labels
    optMotorways: "Autoroutes",
    optTolls: "Frais de douane",
    optFerries: "Ferries",
    optTunnels: "Tunnels",

  optLift: "Hayon",
    // COMMON ACTIONS
    cancel: "Annuler",
    open: "Ouvrir",
    save: "Enregistrer",
    reset: "Réinitialiser",

    // PIN MODAL
    pinTitle: "Saisir le PIN",
    pinDescOpenAdmin: "Saisis ton PIN pour ouvrir le panneau admin.",
    pinPlaceholder4: "PIN (4 chiffres)",
    pinOldPlaceholder4: "Ancien PIN (4 chiffres)",
    pinNewPlaceholder4: "Nouveau PIN (4 chiffres)",
    pinRepeatNew: "Répéter le nouveau PIN",

    pinSetupTitle: "Définir le PIN (4 chiffres)",
    pinChangeTitle: "Changer le PIN",
    pinSetupSubtitle:
      "Définis le PIN une seule fois. Ensuite tu n’auras plus qu’à le saisir.",
    pinChangeSubtitle: "Saisis l’ancien PIN, puis définis le nouveau.",

    pinErrEnter4Digits: "Le PIN doit contenir exactement 4 chiffres (0-9).",
    pinErrNew4Digits: "Le nouveau PIN doit contenir exactement 4 chiffres (0-9).",
    pinErrMismatch: "Les nouveaux PIN ne correspondent pas.",
    pinErrOld4Digits: "L’ancien PIN doit contenir exactement 4 chiffres (0-9).",
    pinInvalid: "PIN incorrect.",

  // ADMIN PANEL
adminPanelTitle: "Panneau admin — tarifs aller / retour",
  adminPanelBusBaseHint: "Vous saisissez les tarifs de base pour le FOURGON. PORTEUR et ARTICULÉ sont calculés automatiquement selon les multiplicateurs définis ci-dessous.",
  adminVehiclePercentTitle: "Multiplicateurs véhicule",
  adminVehiclePercentHint: "Saisissez la majoration en pourcentage par rapport au FOURGON. Exemple : PORTEUR 73% signifie que PORTEUR est calculé comme FOURGON +73%.",
  adminVehicleBase: "base",
  adminVehicleDefaultSolo: "par défaut +73%",
  adminVehicleDefaultTrailer: "par défaut +155%",
  adminVehicleKeepBusZero: "Laissez FOURGON à 0% si vos tarifs sont saisis comme base pour le fourgon.",
  changePin: "Changer le PIN",
  importFromExcel: "Import Excel",
  zone: "Zone",
outPerKm: "Aller (OUT) €/km",
inPerKm: "Retour / directions difficiles (IN) €/km",
rateLabel: "Tarif",
pricingModeOutOutbound: "OUT (aller)",
pricingModeInReturn: "IN (retour)",
pricingModeInHardDirection: "IN (direction difficile)",
  ratesSaved: "Les tarifs ont été enregistrés",
  defaultsRestored: "Tarifs par défaut restaurés",
  fileSelected: "Fichier sélectionné",
    // SHORT DISTANCE + DOMESTIC (AdminPanel)
    shortSettingsTitle: "Paramètres courte distance",
    shortMultiplierLabel: "Multiplicateur short (ex. 1.15 = +15%)",
    shortThresholdLabel: "Courte distance globale jusqu’à (km)",
    domesticRatesTitle: "Tarifs domestiques",
    domesticRatesHint: "Utilisé lorsque l’origine et la destination sont dans le même pays (ex. PL → PL).",
    domesticBusBaseHint: "Il s'agit aussi du tarif de base pour le utilitaire.",
    country: "Pays",
    domPerKm: "DOM €/km",
    domesticShortKmLabel: "Court ≤ km",
    smartRouteTitle: "Saisie rapide de l’itinéraire",
    smartOriginPlaceholder: "Départ : ex. Rzeszów, Rzeszów PL, PL3, PL35-001",
    smartDestPlaceholder: "Destination : ex. Hambourg, Hambourg DE, DE2, DE20095",
    smartPalletsPlaceholder: "Palettes",
    smartWeightPlaceholder: "Poids (t)",
    smartSubmit: "Définir l’itinéraire",
},
es: {
  // APP

    // AUTH
        authLoginBtn: "Iniciar sesión",
    authStartFreeTrial: "Iniciar prueba gratuita",
    authLogoutBtn: "Cerrar sesión",
    billingBuyNow: "Comprar ahora",
    billingManageSubscription: "Gestionar suscripción",
    authTitleLogin: "Iniciar sesión",
    authTitleRegister: "Crear cuenta",
    authSubtitleLogin: "Introduce tu correo y contraseña",
    authSubtitleRegister: "Crea una cuenta (mín. 8 caracteres)",
    authEmail: "Correo",
    authPassword: "Contraseña",
    authRepeatPassword: "Repetir contraseña",
    authSubmitLogin: "Entrar",
    authSubmitRegister: "Registrarse",
    authErrEmailRequired: "El correo es obligatorio.",
    authErrPasswordMin8: "La contraseña debe tener al menos 8 caracteres.",
    authErrPasswordMismatch: "Las contraseñas no coinciden.",
    authErrGeneric: "Algo salió mal.",
    authAccept: "Acepto",
    authTerms: "Términos del servicio",
    authPrivacy: "Política de privacidad / RGPD",
    authErrLegalRequired:
  "Para registrarte, debes aceptar los Términos del servicio y la Política de privacidad / RGPD.",

    trialBannerText: "Prueba: quedan {days} días. Al finalizar, será necesario pasar a la versión completa.",
    trialBannerCta: "Comprar ahora",
    trialCheckoutComingSoon: "Los pagos estarán disponibles pronto.",
    postTrialCtaTitle: "Prueba gratuita finalizada",
    postTrialCtaText: "Para seguir usando tarifas y funciones completas, actualiza al plan FULL.",
    postTrialCtaButton: "Comprar ahora",
demoCtaTitle: "Versión DEMO",
    demoCtaText: "En DEMO usamos una tarifa fija de 0,10 €/km. Inicia sesión o crea una cuenta para desbloquear tarifas completas y el panel de administración.",

    adminOnboardingTitle: "Configura tus propias tarifas",
    adminSetupButton: "Configura tus propias tarifas",
    adminOnboardingText:
  "Puedes calcular rutas de inmediato, pero merece la pena añadir tus propias tarifas en el panel de administración. En la primera entrada también configurarás tu PIN.",
    adminOnboardingOpen: "Panel de administración",
    adminOnboardingLater: "Más tarde",

  appTitle: "Cálculo rápido del transporte por carretera en Europa",
  hint:
    "Haz clic en dos regiones del mapa: primero origen, luego destino.",
  start: "Origen",
  destination: "Destino",
  clearSelection: "Borrar selección",
  clickRegion: "Haz clic en una región del mapa",
  priceLabel: "Precio",
  ratesHint: "Configura tus propias tarifas para adaptar el cálculo a tu empresa",
  driveTimeLabel: "Tiempo de conducción",
  truckEtaLabel: "ETA estimado del camión",
  distanceLabel: "Distancia",
  loadLabel: "Carga",
  sendLabel: "Enviar",
  palletShort: "pal.",
  quoteEmailSubject: "Presupuesto de transporte",

  // SIDE MENU / SUMMARY
  routeSettings: "Configuración de ruta",
  vehicleType: "Tipo de vehículo",
  extraOptions: "Opciones adicionales",
  deadhead: "Aproximación",
  deadheadHint: "Los km de aproximación se añaden a la distancia facturada (tarifa de origen).",
  deadheadPlaceholder: "0",
  distance: "Distancia",
  vehicleRate: "Tarifa del vehículo",
  estimatedPrice: "Precio estimado",
  advanced: "Avanzado",
  admin: "Tarifas",
  perKm: "/ km",

  // VEHICLES
  vehicleVan: "🚐 FURGONETA",
  vehicleSolo: "🚚 RÍGIDO",
  vehicleTrailer: "🚛 ARTICULADO",

  // EXTRA OPTIONS labels
  optMotorways: "Autopistas",
  optTolls: "Peajes",
  optFerries: "Ferries",
  optTunnels: "Túneles",

  optLift: "Trampilla elevadora",
  // COMMON ACTIONS
  cancel: "Cancelar",
  open: "Abrir",
  save: "Guardar",
  reset: "Reset",

  // PIN MODAL
  pinTitle: "Introduce el PIN",
  pinDescOpenAdmin: "Introduce tu PIN para abrir el panel de administración.",
  pinPlaceholder4: "PIN (4 dígitos)",
  pinOldPlaceholder4: "PIN antiguo (4 dígitos)",
  pinNewPlaceholder4: "Nuevo PIN (4 dígitos)",
  pinRepeatNew: "Repite el nuevo PIN",

  pinSetupTitle: "Configurar PIN (4 dígitos)",
  pinChangeTitle: "Cambiar PIN",
  pinSetupSubtitle: "Configura el PIN una sola vez. Luego solo tendrás que introducirlo.",
  pinChangeSubtitle: "Introduce el PIN antiguo y luego configura uno nuevo.",

  pinErrEnter4Digits: "El PIN debe tener exactamente 4 dígitos (0-9).",
  pinErrNew4Digits: "El nuevo PIN debe tener exactamente 4 dígitos (0-9).",
  pinErrMismatch: "Los PIN no coinciden.",
  pinErrOld4Digits: "El PIN antiguo debe tener exactamente 4 dígitos (0-9).",
  pinInvalid: "PIN incorrecto.",

  // ADMIN PANEL
adminPanelTitle: "Panel admin — tarifas salida / regreso",
  adminPanelBusBaseHint: "Introduces las tarifas base para la FURGONETA. RÍGIDO y ARTICULADO se calculan automáticamente según los multiplicadores definidos abajo.",
  adminVehiclePercentTitle: "Multiplicadores de vehículo",
  adminVehiclePercentHint: "Introduce el incremento porcentual respecto a la FURGONETA. Ejemplo: RÍGIDO 73% significa que RÍGIDO se calcula como FURGONETA +73%.",
  adminVehicleBase: "base",
  adminVehicleDefaultSolo: "por defecto +73%",
  adminVehicleDefaultTrailer: "por defecto +155%",
  adminVehicleKeepBusZero: "Deja FURGONETA en 0% si introduces las tarifas como base para la furgoneta.",
  changePin: "Cambiar PIN",
  importFromExcel: "Import Excel",
  zone: "Zona",
outPerKm: "Salida (OUT) €/km",
inPerKm: "Regreso / direcciones difíciles (IN) €/km",
rateLabel: "Tarifa",
pricingModeOutOutbound: "OUT (salida)",
pricingModeInReturn: "IN (regreso)",
pricingModeInHardDirection: "IN (dirección difícil)",
  ratesSaved: "Las tarifas se han guardado",
  defaultsRestored: "Tarifas por defecto restauradas",
  fileSelected: "Archivo seleccionado",
  // SHORT DISTANCE + DOMESTIC (AdminPanel)
  shortSettingsTitle: "Configuración de distancia corta",
  shortMultiplierLabel: "Multiplicador short (p. ej. 1.15 = +15%)",
  shortThresholdLabel: "Distancia corta global hasta (km)",
  domesticRatesTitle: "Tarifas domésticas",
  domesticRatesHint: "Se usa cuando el origen y el destino están en el mismo país (p. ej. PL → PL).",
  domesticBusBaseHint: "Esta también es la tarifa base para la furgoneta.",
  country: "País",
  domPerKm: "DOM €/km",
  domesticShortKmLabel: "Corta ≤ km",
  smartRouteTitle: "Entrada rápida de ruta",
  smartOriginPlaceholder: "Origen: p. ej. Rzeszów, Rzeszów PL, PL3, PL35-001",
  smartDestPlaceholder: "Destino: p. ej. Hamburgo, Hamburgo DE, DE2, DE20095",
  smartPalletsPlaceholder: "Palets",
  smartWeightPlaceholder: "Peso (t)",
  smartSubmit: "Establecer ruta",
},
ro: {
  // APP

    // AUTH
        authLoginBtn: "Autentificare",
    authStartFreeTrial: "Începe perioada de probă gratuită",
    authLogoutBtn: "Deconectare",
    billingBuyNow: "Cumpără acum",
    billingManageSubscription: "Gestionează abonamentul",
    authTitleLogin: "Autentificare",
    authTitleRegister: "Creează cont",
    authSubtitleLogin: "Introdu adresa de email și parola",
    authSubtitleRegister: "Creează un cont (min. 8 caractere)",
    authEmail: "Email",
    authPassword: "Parolă",
    authRepeatPassword: "Repetă parola",
    authSubmitLogin: "Intră",
    authSubmitRegister: "Înregistrare",
    authErrEmailRequired: "Emailul este obligatoriu.",
    authErrPasswordMin8: "Parola trebuie să aibă cel puțin 8 caractere.",
    authErrPasswordMismatch: "Parolele nu se potrivesc.",
    authErrGeneric: "A apărut o eroare.",
    authAccept: "Accept",
    authTerms: "Termeni și condiții",
    authPrivacy: "Politica de confidențialitate / GDPR",
    authErrLegalRequired:
  "Pentru a te înregistra, trebuie să accepți Termenii și condițiile și Politica de confidențialitate / GDPR.",

    trialBannerText: "Perioadă de probă: au rămas {days} zile. După terminare, va fi necesar upgrade la versiunea completă.",
    trialBannerCta: "Cumpără acum",
    trialCheckoutComingSoon: "Plățile vor fi disponibile în curând.",
    postTrialCtaTitle: "Perioada de probă s-a încheiat",
    postTrialCtaText: "Pentru a folosi în continuare tarife și funcții complete, treci la planul FULL.",
    postTrialCtaButton: "Cumpără acum",
demoCtaTitle: "Versiune DEMO",
    demoCtaText: "În DEMO folosim o rată fixă de 0,10 €/km. Autentifică-te sau creează un cont pentru a debloca tarifele complete și panoul de administrare.",

    adminOnboardingTitle: "Setează-ți propriile tarife",
    adminSetupButton: "Setează-ți propriile tarife",
    adminOnboardingText:
  "Poți calcula imediat rutele, dar merită să adaugi propriile tarife în panoul de administrare. La prima accesare îți vei seta și PIN-ul.",
    adminOnboardingOpen: "Panou admin",
    adminOnboardingLater: "Mai târziu",

  appTitle: "Calcul rapid al costului transportului rutier în Europa",
  hint:
    "Fă clic pe două regiuni de pe hartă: mai întâi start, apoi destinația.",
  start: "Start",
  destination: "Destinație",
  clearSelection: "Șterge selecția",
  clickRegion: "Fă clic pe o regiune pe hartă",
  priceLabel: "Preț",
  ratesHint: "Setează propriile tarife pentru ca oferta să se potrivească firmei tale",
  driveTimeLabel: "Timp de conducere",
  truckEtaLabel: "ETA estimat al camionului",
  distanceLabel: "Distanță",
  loadLabel: "Încărcătură",
  sendLabel: "Trimite",
  palletShort: "pal.",
  quoteEmailSubject: "Ofertă de transport",

  // SIDE MENU / SUMMARY
  routeSettings: "Setări rută",
  vehicleType: "Tip vehicul",
  extraOptions: "Opțiuni suplimentare",
  deadhead: "Deplasare",
  deadheadHint: "Km de deplasare se adaugă la distanța facturată (tarif origine).",
  deadheadPlaceholder: "0",
  distance: "Distanță",
  vehicleRate: "Tarif vehicul",
  estimatedPrice: "Preț estimat",
  advanced: "Avansat",
  admin: "Tarife",
  perKm: "/ km",

  // VEHICLES
  vehicleVan: "🚐 VAN",
  vehicleSolo: "🚚 RIGID",
  vehicleTrailer: "🚛 ARTICULAT",

  // EXTRA OPTIONS labels
  optMotorways: "Autostrăzi",
  optTolls: "Taxe",
  optFerries: "Feriboturi",
  optTunnels: "Tuneluri",

  optLift: "Platformă ridicătoare",
  // COMMON ACTIONS
  cancel: "Anulează",
  open: "Deschide",
  save: "Salvează",
  reset: "Reset",

  // PIN MODAL
  pinTitle: "Introdu PIN-ul",
  pinDescOpenAdmin: "Introdu PIN-ul pentru a deschide panoul admin.",
  pinPlaceholder4: "PIN (4 cifre)",
  pinOldPlaceholder4: "PIN vechi (4 cifre)",
  pinNewPlaceholder4: "PIN nou (4 cifre)",
  pinRepeatNew: "Repetă PIN-ul nou",

  pinSetupTitle: "Setează PIN (4 cifre)",
  pinChangeTitle: "Schimbă PIN-ul",
  pinSetupSubtitle: "Setează PIN-ul o singură dată. Apoi doar îl vei introduce.",
  pinChangeSubtitle: "Introdu PIN-ul vechi, apoi setează unul nou.",

  pinErrEnter4Digits: "PIN-ul trebuie să aibă exact 4 cifre (0-9).",
  pinErrNew4Digits: "Noul PIN trebuie să aibă exact 4 cifre (0-9).",
  pinErrMismatch: "PIN-urile nu coincid.",
  pinErrOld4Digits: "PIN-ul vechi trebuie să aibă exact 4 cifre (0-9).",
  pinInvalid: "PIN incorect.",

  // ADMIN PANEL
adminPanelTitle: "Panou admin — tarife plecare / întoarcere",
  adminPanelBusBaseHint: "Introduci tarifele de bază pentru VAN. RIGID și ARTICULAT se calculează automat pe baza multiplicatorilor setați mai jos.",
  adminVehiclePercentTitle: "Multiplicatori vehicul",
  adminVehiclePercentHint: "Introdu majorarea procentuală față de VAN. Exemplu: RIGID 73% înseamnă că RIGID se calculează ca VAN +73%.",
  adminVehicleBase: "bază",
  adminVehicleDefaultSolo: "implicit +73%",
  adminVehicleDefaultTrailer: "implicit +155%",
  adminVehicleKeepBusZero: "Lasă VAN la 0% dacă introduci tarifele ca bază pentru van.",
  changePin: "Schimbă PIN",
  importFromExcel: "Import Excel",
  zone: "Zonă",
outPerKm: "Plecare (OUT) €/km",
inPerKm: "Întoarcere / direcții dificile (IN) €/km",
rateLabel: "Tarif",
pricingModeOutOutbound: "OUT (plecare)",
pricingModeInReturn: "IN (întoarcere)",
pricingModeInHardDirection: "IN (direcție dificilă)",
  ratesSaved: "Tarifele au fost salvate",
  defaultsRestored: "Tarifele implicite au fost restaurate",
  fileSelected: "Fișier selectat",
  // SHORT DISTANCE + DOMESTIC (AdminPanel)
  shortSettingsTitle: "Setări distanță scurtă",
  shortMultiplierLabel: "Multiplicator short (ex. 1.15 = +15%)",
  shortThresholdLabel: "Distanță scurtă globală până la (km)",
  domesticRatesTitle: "Tarife interne",
  domesticRatesHint: "Folosit când originea și destinația sunt în aceeași țară (ex. PL → PL).",
  domesticBusBaseHint: "Și aceasta este tariful de bază pentru dubă.",
  country: "Țară",
  domPerKm: "DOM €/km",
  domesticShortKmLabel: "Scurt ≤ km",
  smartRouteTitle: "Introducere rapidă a rutei",
  smartOriginPlaceholder: "Start: ex. Rzeszów, Rzeszów PL, PL3, PL35-001",
  smartDestPlaceholder: "Destinație: ex. Hamburg, Hamburg DE, DE2, DE20095",
  smartPalletsPlaceholder: "Paleți",
  smartWeightPlaceholder: "Greutate (t)",
  smartSubmit: "Setează ruta",
},
bg: {
  // APP

    // AUTH
        authLoginBtn: "Вход",
    authStartFreeTrial: "Започни безплатен пробен период",
    authLogoutBtn: "Изход",
    billingBuyNow: "Купи сега",
    billingManageSubscription: "Управлявай абонамента",
    authTitleLogin: "Вход",
    authTitleRegister: "Създай акаунт",
    authSubtitleLogin: "Въведи имейл и парола",
    authSubtitleRegister: "Създай акаунт (мин. 8 знака)",
    authEmail: "Имейл",
    authPassword: "Парола",
    authRepeatPassword: "Повтори паролата",
    authSubmitLogin: "Вход",
    authSubmitRegister: "Регистрация",
    authErrEmailRequired: "Имейлът е задължителен.",
    authErrPasswordMin8: "Паролата трябва да е поне 8 знака.",
    authErrPasswordMismatch: "Паролите не съвпадат.",
    authErrGeneric: "Нещо се обърка.",
    authAccept: "Приемам",
    authTerms: "Общи условия",
    authPrivacy: "Политика за поверителност / GDPR",
    authErrLegalRequired:
  "За да се регистрирате, трябва да приемете Общите условия и Политиката за поверителност / GDPR.",
    
    trialBannerText: "Пробен период: остават {days} дни. След края му ще е необходимо преминаване към пълната версия.",
    trialBannerCta: "Купи сега",
    trialCheckoutComingSoon: "Плащанията ще бъдат налични скоро.",
    postTrialCtaTitle: "Безплатният пробен период приключи",
    postTrialCtaText: "За да продължиш да ползваш пълните тарифи и функции, премини към план FULL.",
    postTrialCtaButton: "Купи сега",
demoCtaTitle: "ДЕМО версия",
    demoCtaText: "В ДЕМО използваме фиксирана ставка 0,10 €/км. Влезте или създайте акаунт, за да отключите пълните ставки и админ панела.",

    adminOnboardingTitle: "Задай свои тарифи",
    adminSetupButton: "Задай свои тарифи",
    adminOnboardingText:
  "Можеш веднага да изчисляваш маршрути, но си струва да добавиш собствените си тарифи в админ панела. При първото влизане ще зададеш и своя PIN.",
    adminOnboardingOpen: "Админ панел",
    adminOnboardingLater: "По-късно",

  appTitle: "Бързо изчисляване на разходите за автомобилен транспорт в Европа",
  hint:
    "Кликни върху два региона на картата: първо старт, после дестинация.",
  start: "Старт",
  destination: "Дестинация",
  clearSelection: "Изчисти избора",
  clickRegion: "Кликни върху регион на картата",
  priceLabel: "Цена",
  ratesHint: "Задай собствени тарифи, за да отговаря изчислението на твоя бизнес",
  driveTimeLabel: "Време за шофиране",
  truckEtaLabel: "Очакван ETA на камиона",
  distanceLabel: "Разстояние",
  loadLabel: "Товар",
  sendLabel: "Изпрати",
  palletShort: "пал.",
  quoteEmailSubject: "Оферта за транспорт",

  // SIDE MENU / SUMMARY
  routeSettings: "Настройки на маршрута",
  vehicleType: "Тип превозно средство",
  extraOptions: "Допълнителни опции",
  deadhead: "Подход",
  deadheadHint: "Км подход се добавят към разстоянието за таксуване (стартова тарифа).",
  deadheadPlaceholder: "0",
  distance: "Разстояние",
  vehicleRate: "Тарифа на превозното средство",
  estimatedPrice: "Очаквана цена",
  advanced: "Разширени",
  admin: "Тарифи",
  perKm: "/ км",

  // VEHICLES
  vehicleVan: "🚐 БУС",
  vehicleSolo: "🚚 РИГИДЕН",
  vehicleTrailer: "🚛 ВЛЕКАЧ",

  // EXTRA OPTIONS labels
  optMotorways: "Магистрали",
  optTolls: "Пътни такси",
  optFerries: "Фериботи",
  optTunnels: "Тунели",

  optLift: "Падащ борд",
  // COMMON ACTIONS
  cancel: "Отказ",
  open: "Отвори",
  save: "Запази",
  reset: "Нулиране",

  // PIN MODAL
  pinTitle: "Въведи PIN",
  pinDescOpenAdmin: "Въведи PIN, за да отвориш админ панела.",
  pinPlaceholder4: "PIN (4 цифри)",
  pinOldPlaceholder4: "Стар PIN (4 цифри)",
  pinNewPlaceholder4: "Нов PIN (4 цифри)",
  pinRepeatNew: "Повтори новия PIN",

  pinSetupTitle: "Настрой PIN (4 цифри)",
  pinChangeTitle: "Смени PIN",
  pinSetupSubtitle: "Настрой PIN само веднъж. След това ще го въвеждаш.",
  pinChangeSubtitle: "Въведи стария PIN и после задай нов.",

  pinErrEnter4Digits: "PIN трябва да съдържа точно 4 цифри (0-9).",
  pinErrNew4Digits: "Новият PIN трябва да съдържа точно 4 цифри (0-9).",
  pinErrMismatch: "PIN кодовете не съвпадат.",
  pinErrOld4Digits: "Старият PIN трябва да съдържа точно 4 цифри (0-9).",
  pinInvalid: "Грешен PIN.",

  // ADMIN PANEL
adminPanelTitle: "Админ панел — тарифи изход / връщане",
  adminPanelBusBaseHint: "Въвеждате базовите ставки за БУС. РИГИДЕН и ВЛЕКАЧ се изчисляват автоматично според множителите, зададени по-долу.",
  adminVehiclePercentTitle: "Множители за превозни средства",
  adminVehiclePercentHint: "Въведете процентната надбавка спрямо БУС. Пример: РИГИДЕН 73% означава, че РИГИДЕН се изчислява като БУС +73%.",
  adminVehicleBase: "база",
  adminVehicleDefaultSolo: "по подразбиране +73%",
  adminVehicleDefaultTrailer: "по подразбиране +155%",
  adminVehicleKeepBusZero: "Оставете БУС на 0%, ако въвеждате ставките като базова ставка за бус.",
  changePin: "Смени PIN",
  importFromExcel: "Импорт Excel",
  zone: "Зона",
outPerKm: "Изход (OUT) €/km",
inPerKm: "Връщане / трудни посоки (IN) €/km",
rateLabel: "Тарифа",
pricingModeOutOutbound: "OUT (изход)",
pricingModeInReturn: "IN (връщане)",
pricingModeInHardDirection: "IN (трудна посока)",
  ratesSaved: "Тарифите са записани",
  defaultsRestored: "Възстановени са стандартните тарифи",
  fileSelected: "Избран файл",
  // SHORT DISTANCE + DOMESTIC (AdminPanel)
  shortSettingsTitle: "Настройки за къса дистанция",
  shortMultiplierLabel: "Множител short (напр. 1.15 = +15%)",
  shortThresholdLabel: "Глобална къса дистанция до (км)",
  domesticRatesTitle: "Вътрешни тарифи",
  domesticRatesHint: "Използва се, когато началото и краят са в една и съща държава (напр. PL → PL).",
  domesticBusBaseHint: "Това също е базовата ставка за бус.",
  country: "Държава",
  domPerKm: "DOM €/км",
  domesticShortKmLabel: "Къса ≤ км",
  smartRouteTitle: "Бързо въвеждане на маршрут",
  smartOriginPlaceholder: "Старт: напр. Rzeszów, Rzeszów PL, PL3, PL35-001",
  smartDestPlaceholder: "Дестинация: напр. Hamburg, Hamburg DE, DE2, DE20095",
  smartPalletsPlaceholder: "Палети",
  smartWeightPlaceholder: "Тегло (t)",
  smartSubmit: "Задай маршрут",
},
hr: {
  // APP

    // AUTH
        authLoginBtn: "Prijava",
    authStartFreeTrial: "Započni besplatno probno razdoblje",
    authLogoutBtn: "Odjava",
    billingBuyNow: "Kupi sada",
    billingManageSubscription: "Upravljaj pretplatom",
    authTitleLogin: "Prijava",
    authTitleRegister: "Kreiraj račun",
    authSubtitleLogin: "Unesi email i lozinku",
    authSubtitleRegister: "Kreiraj račun (min. 8 znakova)",
    authEmail: "Email",
    authPassword: "Lozinka",
    authRepeatPassword: "Ponovi lozinku",
    authSubmitLogin: "Prijavi se",
    authSubmitRegister: "Registracija",
    authErrEmailRequired: "Email je obavezan.",
    authErrPasswordMin8: "Lozinka mora imati najmanje 8 znakova.",
    authErrPasswordMismatch: "Lozinke se ne podudaraju.",
    authErrGeneric: "Nešto je pošlo po zlu.",
    authAccept: "Prihvaćam",
    authTerms: "Uvjeti korištenja",
    authPrivacy: "Pravila privatnosti / GDPR",
    authErrLegalRequired:
  "Za registraciju morate prihvatiti Uvjete korištenja i Pravila privatnosti / GDPR.",
    
    trialBannerText: "Probno razdoblje: preostalo je {days} dana. Nakon isteka potrebno je prijeći na punu verziju.",
    trialBannerCta: "Kupi sada",
    trialCheckoutComingSoon: "Plaćanja će uskoro biti dostupna.",
    postTrialCtaTitle: "Besplatno probno razdoblje je završilo",
    postTrialCtaText: "Kako bi nastavio koristiti pune cijene i funkcije, prijeđi na FULL plan.",
    postTrialCtaButton: "Kupi sada",
demoCtaTitle: "DEMO verzija",
    demoCtaText: "U DEMO-u koristimo fiksnu cijenu 0,10 €/km. Prijavite se ili izradite račun kako biste otključali pune cijene i admin panel.",

    adminOnboardingTitle: "Postavi vlastite tarife",
    adminSetupButton: "Postavi vlastite tarife",
    adminOnboardingText:
  "Možeš odmah računati rute, ali vrijedi unijeti vlastite tarife u admin panel. Pri prvom ulasku postavit ćeš i svoj PIN.",
    adminOnboardingOpen: "Admin panel",
    adminOnboardingLater: "Kasnije",

  appTitle: "Brzi izračun troškova cestovnog prijevoza u Europi",
  hint:
    "Klikni na dvije regije na karti: prvo početak, zatim odredište.",
  start: "Početak",
  destination: "Odredište",
  clearSelection: "Očisti odabir",
  clickRegion: "Klikni regiju na karti",
  priceLabel: "Cijena",
  ratesHint: "Postavi vlastite tarife kako bi izračun odgovarao tvojoj firmi",
  driveTimeLabel: "Vrijeme vožnje",
  truckEtaLabel: "Procijenjeni ETA kamiona",
  distanceLabel: "Udaljenost",
  loadLabel: "Teret",
  sendLabel: "Pošalji",
  palletShort: "pal.",
  quoteEmailSubject: "Ponuda prijevoza",

  // SIDE MENU / SUMMARY
  routeSettings: "Postavke rute",
  vehicleType: "Vrsta vozila",
  extraOptions: "Dodatne opcije",
  deadhead: "Dolazak",
  deadheadHint: "Km dolaska dodaju se obračunskoj udaljenosti (tarifa polaska).",
  deadheadPlaceholder: "0",
  distance: "Udaljenost",
  vehicleRate: "Tarifa vozila",
  estimatedPrice: "Procijenjena cijena",
  advanced: "Napredno",
  admin: "Tarife",
  perKm: "/ km",

  // VEHICLES
  vehicleVan: "🚐 KOMBI",
  vehicleSolo: "🚚 KRUTI",
  vehicleTrailer: "🚛 ŠLEPER",

  // EXTRA OPTIONS labels
  optMotorways: "Autoceste",
  optTolls: "Cestarine",
  optFerries: "Trajekti",
  optTunnels: "Tuneli",

  optLift: "Hidraulična rampa",
  // COMMON ACTIONS
  cancel: "Odustani",
  open: "Otvori",
  save: "Spremi",
  reset: "Reset",

  // PIN MODAL
  pinTitle: "Unesi PIN",
  pinDescOpenAdmin: "Unesi PIN za otvaranje admin panela.",
  pinPlaceholder4: "PIN (4 znamenke)",
  pinOldPlaceholder4: "Stari PIN (4 znamenke)",
  pinNewPlaceholder4: "Novi PIN (4 znamenke)",
  pinRepeatNew: "Ponovi novi PIN",

  pinSetupTitle: "Postavi PIN (4 znamenke)",
  pinChangeTitle: "Promijeni PIN",
  pinSetupSubtitle: "Postavi PIN samo jednom. Nakon toga ga samo unosiš.",
  pinChangeSubtitle: "Unesi stari PIN, zatim postavi novi.",

  pinErrEnter4Digits: "PIN mora imati točno 4 znamenke (0-9).",
  pinErrNew4Digits: "Novi PIN mora imati točno 4 znamenke (0-9).",
  pinErrMismatch: "PIN-ovi se ne podudaraju.",
  pinErrOld4Digits: "Stari PIN mora imati točno 4 znamenke (0-9).",
  pinInvalid: "Neispravan PIN.",

  // ADMIN PANEL
adminPanelTitle: "Admin panel — tarife polazak / povratak",
  adminPanelBusBaseHint: "Unosiš osnovne tarife za KOMBI. KRUTI i ŠLEPER izračunavaju se automatski prema množiteljima postavljenima niže.",
  adminVehiclePercentTitle: "Množitelji vozila",
  adminVehiclePercentHint: "Unesi postotno uvećanje u odnosu na KOMBI. Primjer: KRUTI 73% znači da se KRUTI računa kao KOMBI +73%.",
  adminVehicleBase: "baza",
  adminVehicleDefaultSolo: "zadano +73%",
  adminVehicleDefaultTrailer: "zadano +155%",
  adminVehicleKeepBusZero: "Ostavi KOMBI na 0% ako tarife unosiš kao osnovnu tarifu za kombi.",
  changePin: "Promijeni PIN",
  importFromExcel: "Import Excel",
  zone: "Zona",
outPerKm: "Polazak (OUT) €/km",
inPerKm: "Povratak / teški smjerovi (IN) €/km",
rateLabel: "Tarifa",
pricingModeOutOutbound: "OUT (polazak)",
pricingModeInReturn: "IN (povratak)",
pricingModeInHardDirection: "IN (teški smjer)",
  ratesSaved: "Tarife su spremljene",
  defaultsRestored: "Zadane tarife su vraćene",
  fileSelected: "Odabrana datoteka",
  // SHORT DISTANCE + DOMESTIC (AdminPanel)
  shortSettingsTitle: "Postavke kratke udaljenosti",
  shortMultiplierLabel: "Kratki multiplikator (npr. 1.15 = +15%)",
  shortThresholdLabel: "Globalna kratka udaljenost do (km)",
  domesticRatesTitle: "Unutarnje tarife",
  domesticRatesHint: "Koristi se kada su polazište i odredište u istoj državi (npr. PL → PL).",
  domesticBusBaseHint: "I ovo je osnovna tarifa za kombi.",
  country: "Država",
  domPerKm: "DOM €/km",
  domesticShortKmLabel: "Kratko ≤ km",
  smartRouteTitle: "Brzi unos rute",
  smartOriginPlaceholder: "Polazak: npr. Rzeszów, Rzeszów PL, PL3, PL35-001",
  smartDestPlaceholder: "Odredište: npr. Hamburg, Hamburg DE, DE2, DE20095",
  smartPalletsPlaceholder: "Palete",
  smartWeightPlaceholder: "Težina (t)",
  smartSubmit: "Postavi rutu",
},
cs: {
  // APP

    // AUTH
        authLoginBtn: "Přihlásit",
    authStartFreeTrial: "Spustit bezplatnou zkušební verzi",
    authLogoutBtn: "Odhlásit",
    billingBuyNow: "Koupit nyní",
    billingManageSubscription: "Spravovat předplatné",
    authTitleLogin: "Přihlášení",
    authTitleRegister: "Vytvořit účet",
    authSubtitleLogin: "Zadejte email a heslo",
    authSubtitleRegister: "Vytvořte účet (min. 8 znaků)",
    authEmail: "Email",
    authPassword: "Heslo",
    authRepeatPassword: "Zopakovat heslo",
    authSubmitLogin: "Přihlásit",
    authSubmitRegister: "Registrovat",
    authErrEmailRequired: "Email je povinný.",
    authErrPasswordMin8: "Heslo musí mít alespoň 8 znaků.",
    authErrPasswordMismatch: "Hesla se neshodují.",
    authErrGeneric: "Něco se pokazilo.",
    authAccept: "Souhlasím",
    authTerms: "Podmínky použití",
    authPrivacy: "Zásady ochrany osobních údajů / GDPR",
    authErrLegalRequired:
  "Pro registraci musíte souhlasit s Podmínkami použití a Zásadami ochrany osobních údajů / GDPR.",

    trialBannerText: "Zkušební období: zbývá {days} dní. Po skončení bude nutný přechod na plnou verzi.",
    trialBannerCta: "Koupit nyní",
    trialCheckoutComingSoon: "Platby budou brzy k dispozici.",
    postTrialCtaTitle: "Zkušební období skončilo",
    postTrialCtaText: "Chceš‑li dál používat plné sazby a funkce, přejdi na plán FULL.",
    postTrialCtaButton: "Koupit nyní",
demoCtaTitle: "DEMO verze",
    demoCtaText: "V DEMO používáme pevnou sazbu 0,10 €/km. Přihlaste se nebo si vytvořte účet a odemkněte plné sazby a administraci.",

    adminOnboardingTitle: "Nastav si vlastní sazby",
    adminSetupButton: "Nastav si vlastní sazby",
    adminOnboardingText:
  "Trasy můžeš počítat hned, ale vyplatí se doplnit vlastní sazby v admin panelu. Při prvním vstupu si také nastavíš svůj PIN.",
    adminOnboardingOpen: "Admin panel",
    adminOnboardingLater: "Později",

  appTitle: "Rychlý výpočet nákladů silniční dopravy v Evropě",
  hint:
    "Klikni na mapě na dva regiony: nejprve start, poté cíl.",
  start: "Start",
  destination: "Cíl",
  clearSelection: "Vymazat výběr",
  clickRegion: "Klikni na region na mapě",
  priceLabel: "Cena",
  ratesHint: "Nastav si vlastní sazby, aby výpočet odpovídal tvé firmě",
  driveTimeLabel: "Doba jízdy",
  truckEtaLabel: "Odhadovaný ETA kamionu",
  distanceLabel: "Vzdálenost",
  loadLabel: "Náklad",
  sendLabel: "Odeslat",
  palletShort: "pal.",
  quoteEmailSubject: "Cenová nabídka dopravy",

  // SIDE MENU / SUMMARY
  routeSettings: "Nastavení trasy",
  vehicleType: "Typ vozidla",
  extraOptions: "Další možnosti",
  deadhead: "Nájezd",
  deadheadHint: "Km nájezdu se přičítají k účtované vzdálenosti (tarif startu).",
  deadheadPlaceholder: "0",
  distance: "Vzdálenost",
  vehicleRate: "Sazba vozidla",
  estimatedPrice: "Odhadovaná cena",
  advanced: "Pokročilé",
  admin: "Sazby",
  perKm: "/ km",

  // VEHICLES
  vehicleVan: "🚐 DODÁVKA",
  vehicleSolo: "🚚 TUHÝ",
  vehicleTrailer: "🚛 NÁVĚS",

  // EXTRA OPTIONS labels
  optMotorways: "Dálnice",
  optTolls: "Mýtné",
  optFerries: "Trajekty",
  optTunnels: "Tunely",

  optLift: "Hydraulické čelo",
  // COMMON ACTIONS
  cancel: "Zrušit",
  open: "Otevřít",
  save: "Uložit",
  reset: "Reset",

  // PIN MODAL
  pinTitle: "Zadej PIN",
  pinDescOpenAdmin: "Zadej PIN pro otevření admin panelu.",
  pinPlaceholder4: "PIN (4 číslice)",
  pinOldPlaceholder4: "Starý PIN (4 číslice)",
  pinNewPlaceholder4: "Nový PIN (4 číslice)",
  pinRepeatNew: "Zopakuj nový PIN",

  pinSetupTitle: "Nastavit PIN (4 číslice)",
  pinChangeTitle: "Změnit PIN",
  pinSetupSubtitle: "Nastav PIN pouze jednou. Poté jej budeš jen zadávat.",
  pinChangeSubtitle: "Zadej starý PIN a nastav nový.",

  pinErrEnter4Digits: "PIN musí mít přesně 4 číslice (0-9).",
  pinErrNew4Digits: "Nový PIN musí mít přesně 4 číslice (0-9).",
  pinErrMismatch: "PINy se neshodují.",
  pinErrOld4Digits: "Starý PIN musí mít přesně 4 číslice (0-9).",
  pinInvalid: "Neplatný PIN.",

  // ADMIN PANEL
adminPanelTitle: "Admin panel — sazby odjezd / návrat",
  adminPanelBusBaseHint: "Zadáváš základní sazby pro DODÁVKU. TUHÝ a NÁVĚS se automaticky počítají podle níže nastavených násobitelů.",
  adminVehiclePercentTitle: "Násobitele vozidel",
  adminVehiclePercentHint: "Zadej procentní navýšení oproti DODÁVCE. Příklad: TUHÝ 73% znamená, že TUHÝ se počítá jako DODÁVKA +73%.",
  adminVehicleBase: "základ",
  adminVehicleDefaultSolo: "výchozí +73%",
  adminVehicleDefaultTrailer: "výchozí +155%",
  adminVehicleKeepBusZero: "Nech DODÁVKU na 0%, pokud sazby zadáváš jako základ pro dodávku.",
  changePin: "Změnit PIN",
  importFromExcel: "Import Excel",
  zone: "Zóna",
outPerKm: "Odjezd (OUT) €/km",
inPerKm: "Návrat / obtížné směry (IN) €/km",
rateLabel: "Sazba",
pricingModeOutOutbound: "OUT (odjezd)",
pricingModeInReturn: "IN (návrat)",
pricingModeInHardDirection: "IN (obtížný směr)",
  ratesSaved: "Sazby byly uloženy",
  defaultsRestored: "Výchozí sazby byly obnoveny",
  fileSelected: "Vybraný soubor",
  // SHORT DISTANCE + DOMESTIC (AdminPanel)
  shortSettingsTitle: "Nastavení krátké vzdálenosti",
  shortMultiplierLabel: "Short multiplikátor (např. 1.15 = +15%)",
  shortThresholdLabel: "Globální krátká vzdálenost do (km)",
  domesticRatesTitle: "Vnitrostátní sazby",
  domesticRatesHint: "Použije se, když je start i cíl ve stejné zemi (např. PL → PL).",
  domesticBusBaseHint: "I toto je základní sazba pro dodávku.",
  country: "Země",
  domPerKm: "DOM €/km",
  domesticShortKmLabel: "Krátká ≤ km",
  smartRouteTitle: "Rychlé zadání trasy",
  smartOriginPlaceholder: "Start: např. Rzeszów, Rzeszów PL, PL3, PL35-001",
  smartDestPlaceholder: "Cíl: např. Hamburg, Hamburg DE, DE2, DE20095",
  smartPalletsPlaceholder: "Palety",
  smartWeightPlaceholder: "Hmotnost (t)",
  smartSubmit: "Nastavit trasu",
},
sk: {
  // APP

    // AUTH
        authLoginBtn: "Prihlásiť",
    authStartFreeTrial: "Spustiť bezplatnú skúšobnú verziu",
    authLogoutBtn: "Odhlásiť",
    billingBuyNow: "Kúpiť teraz",
    billingManageSubscription: "Spravovať predplatné",
    authTitleLogin: "Prihlásenie",
    authTitleRegister: "Vytvoriť účet",
    authSubtitleLogin: "Zadajte email a heslo",
    authSubtitleRegister: "Vytvorte účet (min. 8 znakov)",
    authEmail: "Email",
    authPassword: "Heslo",
    authRepeatPassword: "Zopakovať heslo",
    authSubmitLogin: "Prihlásiť",
    authSubmitRegister: "Registrovať",
    authErrEmailRequired: "Email je povinný.",
    authErrPasswordMin8: "Heslo musí mať aspoň 8 znakov.",
    authErrPasswordMismatch: "Heslá sa nezhodujú.",
    authErrGeneric: "Niečo sa pokazilo.",
    authAccept: "Súhlasím",
    authTerms: "Podmienky používania",
    authPrivacy: "Zásady ochrany osobných údajov / GDPR",
    authErrLegalRequired:
  "Pre registráciu musíte súhlasiť s Podmienkami používania a Zásadami ochrany osobných údajov / GDPR.",

    trialBannerText: "Skúšobné obdobie: zostáva {days} dní. Po skončení bude potrebný prechod na plnú verziu.",
    trialBannerCta: "Kúpiť teraz",
    trialCheckoutComingSoon: "Platby budú čoskoro dostupné.",
    postTrialCtaTitle: "Skúšobné obdobie skončilo",
    postTrialCtaText: "Ak chceš ďalej používať plné sadzby a funkcie, prejdi na plán FULL.",
    postTrialCtaButton: "Kúpiť teraz",
demoCtaTitle: "DEMO verzia",
    demoCtaText: "V DEMO používame pevnú sadzbu 0,10 €/km. Prihláste sa alebo si vytvorte účet a odomknite plné sadzby a admin panel.",

    adminOnboardingTitle: "Nastav si vlastné sadzby",
    adminSetupButton: "Nastav si vlastné sadzby",
    adminOnboardingText:
  "Trasy môžeš počítať hneď, ale oplatí sa doplniť vlastné sadzby v admin paneli. Pri prvom vstupe si nastavíš aj svoj PIN.",
    adminOnboardingOpen: "Admin panel",
    adminOnboardingLater: "Neskôr",

  appTitle: "Rýchly výpočet nákladov cestnej dopravy v Európe",
  hint:
    "Klikni na mape na dva regióny: najprv štart, potom cieľ.",
  start: "Štart",
  destination: "Cieľ",
  clearSelection: "Vymazať výber",
  clickRegion: "Klikni na región na mape",
  priceLabel: "Cena",
  ratesHint: "Nastav si vlastné sadzby, aby výpočet zodpovedal tvojej firme",
  driveTimeLabel: "Čas jazdy",
  truckEtaLabel: "Odhadovaný ETA kamióna",
  distanceLabel: "Vzdialenosť",
  loadLabel: "Náklad",
  sendLabel: "Odoslať",
  palletShort: "pal.",
  quoteEmailSubject: "Cenová ponuka dopravy",

  // SIDE MENU / SUMMARY
  routeSettings: "Nastavenia trasy",
  vehicleType: "Typ vozidla",
  extraOptions: "Doplnkové možnosti",
  deadhead: "Nájazd",
  deadheadHint: "Km nájazdu sa pripočítajú k účtovanej vzdialenosti (tarif štartu).",
  deadheadPlaceholder: "0",
  distance: "Vzdialenosť",
  vehicleRate: "Sadzba vozidla",
  estimatedPrice: "Odhadovaná cena",
  advanced: "Pokročilé",
  admin: "Sadzby",
  perKm: "/ km",

  // VEHICLES
  vehicleVan: "🚐 DODÁVKA",
  vehicleSolo: "🚚 TUHÝ",
  vehicleTrailer: "🚛 NÁVES",

  // EXTRA OPTIONS labels
  optMotorways: "Diaľnice",
  optTolls: "Mýto",
  optFerries: "Trajekty",
  optTunnels: "Tunely",

  optLift: "Hydraulické čelo",
  // COMMON ACTIONS
  cancel: "Zrušiť",
  open: "Otvoriť",
  save: "Uložiť",
  reset: "Reset",

  // PIN MODAL
  pinTitle: "Zadaj PIN",
  pinDescOpenAdmin: "Zadaj PIN pre otvorenie admin panelu.",
  pinPlaceholder4: "PIN (4 číslice)",
  pinOldPlaceholder4: "Starý PIN (4 číslice)",
  pinNewPlaceholder4: "Nový PIN (4 číslice)",
  pinRepeatNew: "Zopakuj nový PIN",

  pinSetupTitle: "Nastaviť PIN (4 číslice)",
  pinChangeTitle: "Zmeniť PIN",
  pinSetupSubtitle: "Nastav PIN iba raz. Potom ho budeš len zadávať.",
  pinChangeSubtitle: "Zadaj starý PIN a nastav nový.",

  pinErrEnter4Digits: "PIN musí mať presne 4 číslice (0-9).",
  pinErrNew4Digits: "Nový PIN musí mať presne 4 číslice (0-9).",
  pinErrMismatch: "PINy sa nezhodujú.",
  pinErrOld4Digits: "Starý PIN musí mať presne 4 číslice (0-9).",
  pinInvalid: "Neplatný PIN.",

  // ADMIN PANEL
adminPanelTitle: "Admin panel — sadzby odchod / návrat",
  adminPanelBusBaseHint: "Zadávaš základné sadzby pre DODÁVKU. TUHÝ a NÁVES sa automaticky počítajú podľa nižšie nastavených násobiteľov.",
  adminVehiclePercentTitle: "Násobitele vozidiel",
  adminVehiclePercentHint: "Zadaj percentuálne navýšenie oproti DODÁVKE. Príklad: TUHÝ 73% znamená, že TUHÝ sa počíta ako DODÁVKA +73%.",
  adminVehicleBase: "základ",
  adminVehicleDefaultSolo: "predvolené +73%",
  adminVehicleDefaultTrailer: "predvolené +155%",
  adminVehicleKeepBusZero: "Nechaj DODÁVKU na 0%, ak sadzby zadávaš ako základ pre dodávku.",
  changePin: "Zmeniť PIN",
  importFromExcel: "Import Excel",
  zone: "Zóna",
outPerKm: "Odchod (OUT) €/km",
inPerKm: "Návrat / náročné smery (IN) €/km",
rateLabel: "Sadzba",
pricingModeOutOutbound: "OUT (odchod)",
pricingModeInReturn: "IN (návrat)",
pricingModeInHardDirection: "IN (náročný smer)",
  ratesSaved: "Sadzby boli uložené",
  defaultsRestored: "Predvolené sadzby boli obnovené",
  fileSelected: "Vybraný súbor",
  // SHORT DISTANCE + DOMESTIC (AdminPanel)
  shortSettingsTitle: "Nastavenia krátkej vzdialenosti",
  shortMultiplierLabel: "Short multiplikátor (napr. 1.15 = +15%)",
  shortThresholdLabel: "Globálna krátka vzdialenosť do (km)",
  domesticRatesTitle: "Vnútroštátne sadzby",
  domesticRatesHint: "Používa sa, keď je štart aj cieľ v rovnakej krajine (napr. PL → PL).",
  domesticBusBaseHint: "Aj toto je základná sadzba pre dodávku.",
  country: "Krajina",
  domPerKm: "DOM €/km",
  domesticShortKmLabel: "Krátka ≤ km",
  smartRouteTitle: "Rýchle zadanie trasy",
  smartOriginPlaceholder: "Štart: napr. Rzeszów, Rzeszów PL, PL3, PL35-001",
  smartDestPlaceholder: "Cieľ: napr. Hamburg, Hamburg DE, DE2, DE20095",
  smartPalletsPlaceholder: "Palety",
  smartWeightPlaceholder: "Hmotnosť (t)",
  smartSubmit: "Nastaviť trasu",
}
} as const;

export type TKey = keyof typeof translations.en;
